<template>
	<div id="buildingLeftCenter">
		<dv-border-box-6>
			<div class="d-flex pt-2 pl-2">
				<div class="d-flex">
					<span class="mt-3 ml-3 title_t">用能监控</span>
				</div>
			</div>
			<div>
				<div class="yes-list d-flex jc-around pt-3">
					<div>
						<span style="font-size: 0.2rem;color: darkgray;">昨日用能</span>
						<div style="margin: 0.2rem 0 0.2rem 0.3375rem;">
							<p>{{ energyData.yesterday_energy }}度</p>
						</div>
						<span style="display: inline-block;width: 1.875rem;text-overflow:ellipsis;height: 0.25rem">
							同比去年
							<span>
								<i class="el-icon-caret-top" v-if="up1" style="color: orangered;font-size: 24px;"></i>
								<i class="el-icon-caret-bottom" v-else style="color: limegreen;font-size: 24px;"></i>
								<span style="font-size: 0.28rem;">{{ comData.com1 }}</span>%
							</span>
						</span>
					</div>
					<div>
						<span style="font-size: 0.2rem;color: darkgray;">本月用能</span>
						<div style="margin: 0.2rem 0 0.2rem 0.3375rem;">
							<p>{{ energyData.month_energy }}度</p>
						</div>
						<span style="display: inline-block;width: 1.875rem;text-overflow:ellipsis">
							同比去年
							<span>
								<!-- <icon name="sort-up" v-if="up2" style="color: orangered;"></icon>
								<icon name="sort-down" v-else style="color: limegreen;"></icon> -->
								<i class="el-icon-caret-top" v-if="up2" style="color: orangered;font-size: 24px;"></i>
								<i class="el-icon-caret-bottom" v-else style="color: limegreen;font-size: 24px;"></i>
								<span style="font-size: 0.28rem;">{{ comData.com2 }}</span>%
							</span>
						</span>
					</div>
					<div>
						<span style="font-size: 0.2rem;color: darkgray;">本年用能</span>
						<div style="margin: 0.2rem 0 0.2rem 0.3375rem;">
							<p>{{ energyData.year_energy }}度</p>
						</div>
						<span style="display: inline-block;width: 1.875rem;text-overflow:ellipsis">
							同比去年
							<span>
								<i class="el-icon-caret-top" v-if="up3" style="color: orangered;font-size: 24px;"></i>
								<i class="el-icon-caret-bottom" v-else style="color: limegreen;font-size: 24px;"></i>
								<span style="font-size: 0.28rem;">{{ comData.com3 }}</span>%
							</span>
						</span>
					</div>
				</div>

				<div class="year-energy mt-4">
					<p style="padding: 0.15rem 0.2rem 0.15rem 0.23rem;color: darkgray;">单位体积用能（上年）</p>
					<div>
						<div class="d-flex" style="margin-left: 0.14rem;">
							<p>阴凉库 <span>{{ rank.shade.unit_dnsj }}</span> 度/m³·年</p>
							<p class="ml-5">排名情况 <span class="rank">{{ rank.shade.rank }} / {{ rank.shade.building_count }}</span></p>
						</div>
						<div class="d-flex" style="margin-left: 0.14rem;">
							<p>常温库 <span>{{ rank.normal.unit_dnsj }}</span> 度/m³·年</p>
							<p class="ml-5">排名情况 
								<span class="rank" v-if="rank.normal.rank=='无'">无</span>
								<span class="rank" v-else>{{ rank.normal.rank }} / {{ rank.normal.building_count }}</span>
							</p>
						</div>
					</div>
				</div>
			</div>
		</dv-border-box-6>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				energyData: {
					yesterday_energy: 0,
					last_yesterday_energy: 0,
					month_energy: 0,
					last_month_energy: 0,
					year_energy: 0,
					last_year_energy: 0
				},
				up1: true,
				up2: true,
				up3: true,
				comData: {},
				rank: {
					shade: {
						rank: 0,
						unit_dnsj: 0,
						building_count: 0
					},
					normal: {
						rank: 0,
						unit_dnsj: 0,
						building_count: 0
					}
				}
			};
		},
		components: {

		},
		props: ['building'],
		watch: {
			'building': {
				handler() {
					this.buildingRank();
					this.energyMonitor()
				},
			}
		},
		mounted() {
			this.buildingRank()
			this.energyMonitor()
		},
		methods: {
			async buildingRank() {
				let dataObj = {
					building_id: this.building,
				}
				await this.$axios.get("/api/buildings/buildingRank", {
					params: dataObj
				}).then(res => {
					this.rank = res.data.data
				})
			},
			async energyMonitor() {
				let dataObj = {
					building_id: this.building,
				}
				await this.$axios.get("/api/buildings/energyMonitor", {
					params: dataObj
				}).then(res => {
					this.energyData.yesterday_energy = res.data.data.yesterday_energy ? res.data.data
						.yesterday_energy : 0
					this.energyData.last_yesterday_energy = res.data.data.last_yesterday_energy ? res.data.data
						.last_yesterday_energy : 0
					this.energyData.month_energy = res.data.data.month_energy ? res.data.data.month_energy : 0
					this.energyData.last_month_energy = res.data.data.last_month_energy ? res.data.data
						.last_month_energy : 0
					this.energyData.year_energy = res.data.data.year_energy ? res.data.data.year_energy : 0
					this.energyData.last_year_energy = res.data.data.last_year_energy ? res.data.data
						.last_year_energy : 0
					let comData = {
						com1: res.data.data.yesterday_energy ? Math.abs(((res.data.data.yesterday_energy -
								res.data.data.last_yesterday_energy) / res.data.data
							.yesterday_energy * 100).toFixed(0)) : '100',
						com2: res.data.data.month_energy ? Math.abs(((res.data.data.month_energy -
								res.data.data.last_month_energy) / res.data.data.month_energy *
							100).toFixed(0)) : '100',
						com3: res.data.data.year_energy ? Math.abs(((res.data.data.year_energy -
								res.data.data.last_year_energy) / res.data.data.year_energy * 100)
							.toFixed(0)) : '100',
					}
					this.comData = comData
					if (parseInt(res.data.data.yesterday_energy) > parseInt(res.data.data
							.last_yesterday_energy)) {
						this.up1 = true
					} else {
						this.up1 = false
					}
					if (parseInt(res.data.data.month_energy) > parseInt(res.data.data.last_month_energy)) {
						this.up2 = true
					} else {
						this.up2 = false
					}
					if (parseInt(res.data.data.year_energy) > parseInt(res.data.data.last_year_energy)) {
						this.up3 = true
					} else {
						this.up3 = false
					}
				})
			},
		},
	};
</script>

<style lang="scss">
	#buildingLeftCenter {
		height: 3.875rem;
		width: 6.45rem;

		.yes-list {
			width: 100%;
			height: 1.5rem;
			text-align: center;
			color: #fff;

			div {
				span {
					font-size: 0.18rem;
				}

				div {
					width: 1.25rem;
					height: 0.5rem;
					line-height: 0.5rem;
					border: 1px solid #2CDFE8;
					transform-origin: 0 0;
					transform: skew(-20deg);

					p {
						transform-origin: 0 0;
						transform: skew(20deg);
						padding-right: 0.125rem;
						font-size: 0.1875rem;
					}
				}
			}
		}

		.year-energy {
			height: 2rem;

			p {
				font-size: 0.18rem;
			}

			div {
				p {
					color: #fff;
					font-size: 0.1875rem;
					padding: 0.125rem;
					
					.rank{
						width: 1.4rem;
					}
					span {
						color: #18FEFE;
						font-size: 0.275rem;
						display: inline-block;
						width: 0.75rem;
						margin-left: 0.2rem;
					}
				}
			}
		}
	}
</style>
